import { Euler, MeshBasicMaterial, Quaternion } from 'three';
import { ActionControllerEventName, Tween, ViewerModule } from '@verybigthings/vbt-webvr-framework';
export default class ResultJarModule extends ViewerModule {
    constructor(model, table, uiContainer, parentLevel) {
        super();
        // 2.86, 88.42, 0.09
        this.uiObject.name = 'ResultJarModule';
        this.model = model;
        this.parentLevel = parentLevel;
        this.bottle = model.getObjectByName('result_jar_body');
        this.cap = table.getObjectByName('result_jar_cap');
        this.water = model.getObjectByName('water_result_jar');
        this.water.scale.y = 0.01;
        this.water.visible = false;
        this.model.material = new MeshBasicMaterial();
        this.table = table;
        this.defaultPosition = model.position.clone();
        // this.addObject(this.uiContainer = uiContainer);
        this.uiContainer = uiContainer;
    }
    toggleCap(open = true) {
        const finalRotateVal = open ? new Euler(-3, 0, 0) : new Euler();
        this.rotateTo(finalRotateVal, 400, () => {
            this.fire('cap_toggled');
        });
    }
    rotateTo(newEuler, time = 600, onComplete) {
        const oldQuaternion = this.cap.quaternion.clone();
        const newQuaternion = new Quaternion().setFromEuler(newEuler);
        new Tween({ alpha: 0 })
            .to({ alpha: 1 }, time)
            .easing(TWEEN.Easing.Linear.None)
            .onUpdate((alpha) => {
            const quat = oldQuaternion.clone().slerp(newQuaternion.clone(), alpha);
            this.cap.quaternion.copy(quat);
        })
            .onComplete(() => onComplete && onComplete())
            .start();
    }
    waitToggleCap(open = true) {
        console.log('waitToggleCap');
        this.actionController.once(ActionControllerEventName.click, this.cap, () => {
            this.toggleCap(open);
        });
    }
}
